import { Directive, Output, EventEmitter, ElementRef } from '@angular/core';
import * as $ from 'jquery';
import 'bootstrap-datepicker';
@Directive({
  selector: '[datepicker]'
})
export class DatepickerDirective {

    @Output()
    change: EventEmitter<string> = new EventEmitter();

    changedDate: string;
    constructor(private elementRef: ElementRef) {
    }

    ngOnInit() {
        const that = this;
        (<any>$(this.elementRef.nativeElement)).datepicker({
            autoclose: true,
            orientation: "bottom auto",
        }
        ).on('changeDate', function (e) {
            that.change.emit(e);
        });
    }

}
